import React, { Component } from 'react';
import { SVGIcon } from '@homeaway/react-svg';
import { CLOSE__12 } from '@homeaway/svg-defs';
import PropTypes from 'prop-types';

import './Banner.less';

const CNAME = 'Banner';

export default class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.visible
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };

  render() {
    return this.state.visible && (
      <div className={CNAME}>
        <p className={`${CNAME}__text`} dangerouslySetInnerHTML={{ __html: this.props.text }} />
        <button className={`${CNAME}__close`} onClick={this.toggle}>
          <SVGIcon markup={CLOSE__12} />
        </button>
      </div>
    );
  }
}

Banner.defaultProps = {
  visible: true
};

Banner.propTypes = {
  visible: PropTypes.bool,
  text: PropTypes.string.isRequired
};
